import { DIRECTIONS } from '@btime/constants'
import { useDrop } from 'react-dnd'
import React from 'react'

import { Grid } from '../../packages/kiti/components/structure/Grid'
import { Relative } from '../../packages/kiti/components/helpers/Position'
import { useIsDraggingType } from './DndHandler'
import Panel from '../../packages/kiti/components/structure/Panel'

const Droppable = ({ onDrop, type, children, placeholderWidth }) => {
  const isDragging = useIsDraggingType(type)

  const [{ isOverLeft }, dropOnLeftWrapper] = useDrop({
    accept: type,
    collect: monitor => ({
      isOverLeft: monitor.isOver({ shallow: true })
    }),
    drop(item, monitor) {
      onDrop(item, DIRECTIONS.UP)
    }
  })

  const [{ isOverRight }, dropOnRightWrapper] = useDrop({
    accept: type,
    collect: monitor => ({
      isOverRight: monitor.isOver({ shallow: true })
    }),
    drop(item, monitor) {
      onDrop(item, DIRECTIONS.DOWN)
    }
  })

  const placeholder = <Panel lineBorder noMargin noRadius width={placeholderWidth || 20}></Panel>

  const commonStyle = {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: isDragging ? 10 : -1
  }

  return (
    <Relative zIndex={0}>
      <div ref={dropOnLeftWrapper} style={{ ...commonStyle, right: '50%' }}></div>
      <div ref={dropOnRightWrapper} style={{ ...commonStyle, left: '50%' }}></div>
      <Grid gap={0.5}>
        {isOverLeft && placeholder}
        {children}
        {isOverRight && placeholder}
      </Grid>
    </Relative>
  )
}

export default Droppable
